import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders,HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FiedappService {

  constructor(private router: Router,private http: HttpClient) { }
  
  getdashboardCount(): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.get(`${environment.APIEndpoint}/getattendanceDetails`,{ headers });
  }
  getDailyattendancedetails(form:any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${environment.APIEndpoint}/getDailyAttendanceDetails`,form,{ headers });
  }

  deviceResetdetails(form:any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${environment.APIEndpoint}/getdeviceinfo`,form,{ headers });
  }
  deleteEmployeeDetail(form:any): Observable<any>{  
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(`${environment.APIEndpoint}/getdevice_reset`,form,{ headers });

  }

}
